import type { Project } from '@/lib/projects';
import { ProjectIcon } from './ProjectIcon';

type Props = {
  project: Project;
};

export function BrowserMockup({ project }: Props) {
  const mockupUrl =
    project.domain ??
    (project.links?.[0]
      ? project.links[0].url.replace(/^https?:\/\//, '')
      : `${project.slug}.app`);
  return (
    <div
      className="group/mockup relative w-full transition-all duration-[400ms] ease-out"
      style={{
        borderRadius: 'var(--radius-xl)',
        background: 'var(--bg-subtle)',
        border: '1px solid var(--border)',
        boxShadow: 'var(--shadow-lg)',
        overflow: 'hidden',
      }}
    >
      {/* Browser chrome */}
      <div
        className="flex items-center gap-3 px-3"
        style={{
          height: 32,
          borderBottom: '1px solid var(--border)',
          background: 'var(--bg-elevated)',
        }}
      >
        <div className="flex items-center gap-1.5">
          <span
            className="block rounded-full"
            style={{ width: 8, height: 8, background: '#ef4444' }}
          />
          <span
            className="block rounded-full"
            style={{ width: 8, height: 8, background: '#f59e0b' }}
          />
          <span
            className="block rounded-full"
            style={{ width: 8, height: 8, background: '#22c55e' }}
          />
        </div>
        <div
          className="flex-1 rounded-md flex items-center px-3"
          style={{
            height: 18,
            background: 'var(--bg-primary)',
            border: '1px solid var(--border)',
          }}
        >
          <span
            className="font-mono truncate"
            style={{ fontSize: 10, color: 'var(--text-muted)' }}
          >
            {mockupUrl}
          </span>
        </div>
      </div>

      {/* Content */}
      <div
        className="relative flex items-center justify-center"
        style={{
          aspectRatio: '16 / 10',
          background: project.gradient,
        }}
      >
        <div
          className="absolute inset-0 opacity-30"
          style={{
            background:
              'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.25), transparent 55%)',
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(180deg, transparent 60%, rgba(6,6,11,0.35) 100%)',
          }}
        />
        <div className="relative flex flex-col items-center gap-4 text-center px-6">
          <ProjectIcon initials={project.initials} gradient={project.gradient} size={68} />
          <div>
            <div
              className="font-display italic"
              style={{ fontSize: 28, color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}
            >
              {project.name}
            </div>
            <div
              className="mt-1.5 font-mono"
              style={{
                fontSize: 10,
                color: 'rgba(255,255,255,0.75)',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
              }}
            >
              {project.categoryLabel}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
